var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViperLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3_copy_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 580 150",
    style: {
      enableBackground: "new 0 0 580 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8A3C83;}\n\t.st1{fill:#078CBA;}\n\t.st2{fill:#C84261;}\n\t.st3{fill:#BC312A;}\n\t.st4{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_copy_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.4,75c0-38.2-30.9-69.1-69.1-69.1V75H200.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.3,5.9C93.1,5.9,62.2,36.8,62.2,75h69.1V5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.2,75c0,38.2,30.9,69.1,69.1,69.1V75H62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.3,75v69.1c38.2,0,69.1-30.9,69.1-69.1C200.4,75,131.3,75,131.3,75z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.9,
    y: 22.4,
    className: "st4",
    width: 16,
    height: 102.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 22.4,
    className: "st4",
    width: 16,
    height: 102.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.6,81.3l1,0.8c1.7,1.4,3.6,2.5,5.6,3.4c2,1,4.1,1.4,6.3,1.4c0.5,0,1-0.1,1.6-0.1c0.6-0.1,1.1-0.3,1.6-0.5 c0.5-0.3,0.9-0.6,1.2-1c0.4-0.4,0.5-0.9,0.5-1.5s-0.1-1-0.5-1.4c-0.4-0.4-0.6-0.6-1-0.8s-0.9-0.4-1.4-0.5s-1-0.1-1.4-0.3l-3.8-0.8 c-1.9-0.4-3.6-0.9-5.2-1.7c-1.6-0.8-3.1-1.7-4.3-2.9c-1.2-1.1-2.2-2.5-3-4.2c-0.7-1.7-1-3.4-1-5.6c0-3.2,0.6-6,2-8.5 c1.4-2.5,3-4.6,5.2-6.2c2.1-1.7,4.6-2.9,7.3-3.8c2.7-0.9,5.5-1.4,8.4-1.4c6.1,0,11.5,1.5,16.6,4.7l-5.2,13.9 c-1.6-1.1-3.3-2-5.2-2.9c-1.9-0.9-3.7-1.1-5.8-1.1c-0.5,0-0.9,0.1-1.4,0.1c-0.5,0.1-1,0.3-1.4,0.5c-0.5,0.1-0.7,0.5-1,0.9 c-0.2,0.4-0.5,0.8-0.5,1.4c0,0.5,0.1,0.9,0.4,1.3c0.2,0.3,0.6,0.5,1,0.8c0.4,0.1,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.1,1.2,0.3l4.3,1 c2,0.5,3.8,1,5.6,1.9c1.7,0.8,3.1,1.8,4.3,3.1c1.2,1.3,2.2,2.7,2.8,4.5c0.7,1.7,1,3.7,1,6c0,3.2-0.6,6-2,8.4c-1.4,2.4-3,4.5-5.2,6 c-2.1,1.7-4.6,2.8-7.3,3.6c-2.7,0.8-5.5,1.1-8.3,1.1c-3.3,0-6.8-0.5-10.3-1.4c-3.6-0.9-6.8-2-9.8-3.6L227.6,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.2,63.1l5.9-0.3v14.4l-5.9-0.4v23.6h-18.1V77l-4.3,0.4V62.8l4.3,0.3V50.4h18.1V63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.4,46.8h35.2v14.8h-16.1v5.1h14.6v14h-14.6V86h16.6v14.8h-35.7V46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344,46.8h24.2c3.1,0,5.8,0.5,8.4,1.3c2.6,0.8,4.8,2,6.7,3.7c2,1.7,3.3,3.7,4.5,6.2c1,2.5,1.6,5.4,1.6,8.7 c0,2.8-0.5,5.2-1.2,7.5c-0.7,2.2-2,4.1-3.3,5.6c-1.5,1.5-3.3,2.7-5.5,3.6c-2.2,0.8-4.6,1.3-7.2,1.3h-9.7v16.2h-18.3L344,46.8 L344,46.8z M362.2,70.7h1.9c0.9,0,1.6-0.1,2.5-0.1s1.6-0.4,2.2-0.8c0.6-0.4,1.2-0.9,1.6-1.5c0.5-0.6,0.6-1.5,0.6-2.5 c0-1-0.2-1.9-0.7-2.4c-0.5-0.6-1-1-1.6-1.4c-0.7-0.3-1.4-0.5-2.2-0.5c-0.9-0.1-1.6-0.1-2.5-0.1h-1.9v9.4 C362.1,70.7,362.2,70.7,362.2,70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M397.7,81.3l1,0.8c1.7,1.4,3.6,2.5,5.6,3.4c2,1,4.1,1.4,6.3,1.4c0.5,0,1-0.1,1.6-0.1c0.6-0.1,1.1-0.3,1.6-0.5 c0.5-0.3,0.9-0.6,1.2-1c0.4-0.4,0.5-0.9,0.5-1.5s-0.1-1-0.5-1.4c-0.2-0.4-0.6-0.6-1-0.8c-0.4-0.1-0.9-0.4-1.4-0.5 c-0.5-0.1-1-0.1-1.4-0.3l-3.8-0.8c-1.9-0.4-3.6-0.9-5.2-1.7c-1.6-0.8-3.1-1.7-4.3-2.9c-1.2-1.1-2.2-2.5-3-4.2 c-0.7-1.7-1-3.4-1-5.6c0-3.2,0.6-6,2-8.5c1.4-2.5,3-4.6,5.2-6.2c2.1-1.7,4.6-2.9,7.3-3.8c2.7-0.9,5.5-1.4,8.4-1.4 c6.1,0,11.5,1.5,16.6,4.7l-5.2,13.8c-1.6-1.1-3.3-2-5.2-2.9c-1.9-0.9-3.7-1.1-5.8-1.1c-0.5,0-0.9,0.1-1.4,0.1 c-0.5,0.1-1,0.3-1.4,0.5c-0.5,0.1-0.7,0.5-1,0.9c-0.2,0.4-0.5,0.8-0.5,1.4c0,0.5,0.1,0.9,0.4,1.3c0.2,0.3,0.6,0.5,1,0.8 c0.4,0.1,0.7,0.4,1.2,0.5c0.5,0.1,0.9,0.1,1.2,0.3l4.3,1c2,0.5,3.8,1,5.6,1.9c1.7,0.8,3.1,1.8,4.3,3.1c1.2,1.3,2.2,2.7,2.8,4.5 c0.7,1.7,1,3.7,1,6c0,3.2-0.6,6-2,8.4c-1.4,2.4-3,4.5-5.2,6c-2.1,1.7-4.6,2.8-7.3,3.6c-2.7,0.8-5.5,1.1-8.3,1.1 c-3.3,0-6.8-0.5-10.3-1.4c-3.6-0.9-6.8-2-9.8-3.6L397.7,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M469.5,46.8h19.1v53.8h-19.1V46.8L469.5,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M497.5,46.8h19.1v53.8h-19.1V46.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViperLogo);
export default __webpack_public_path__ + "static/media/viper-logo.bff6a48d5d23e2eacfacf3a284554299.svg";
export { ForwardRef as ReactComponent };